import React from 'react';

import { Heading, Body } from '@depop/web-thrift-ui/Typography';
import { Modal } from '@depop/web-ui-kit/Modal';

import styles from './ContextualSignupModalV2.module.css';

import { CombinedFlowHeader } from '@/components/CombinedFlowHeader';
import { buildStaticUrl } from '@/constants/endpoints';

type Props = {
  children: React.ReactNode;
  headingText: string;
  bodyText: string;
  image: string;
  combinedFlow?: boolean;
};

export function ContextualSignupModalV2({
  children,
  headingText,
  bodyText,
  image,
  combinedFlow = false,
}: Props) {
  return (
    <Modal
      isOpen={true}
      setOpen={() => null}
      hideCloseButton
      className={styles.fullscreen}
      labelledBy="contextual-signup-modal-heading"
      content={() => (
        <>
          {combinedFlow ? (
            <CombinedFlowHeader className={styles.combinedFlowHeader} />
          ) : (
            <div className={styles.header}>
              <img
                src={buildStaticUrl('/web/assets/partners/DEPOP_LOGO.png')}
                alt="Depop"
                width={120}
              />
            </div>
          )}
          <div className={styles.container}>
            <img src={image} alt="" />
            <Heading id="contextual-signup-modal-heading" variant="md">
              {headingText}
            </Heading>
            <Body>{bodyText}</Body>
            <div>{children}</div>
          </div>
        </>
      )}
    />
  );
}
